import { TransactionType } from '../../../entities/transactions-v1/query-types';

export type FilterSet = {
  title: string;
  active?: boolean;
  activeFileTypeFilter: TransactionType;
};

const fileTypeFilters: FilterSet[] = [
  {
    title: 'Message',
    active: false,
    activeFileTypeFilter: TransactionType.message,
  },
  {
    title: 'Command',
    active: false,
    activeFileTypeFilter: TransactionType.command,
  },
  {
    title: 'File',
    active: false,
    activeFileTypeFilter: TransactionType.dataFile,
  },
];

export default fileTypeFilters;
